import { useEffect, useState } from "react";

export default function useFaqAccordion(faqs) {
    const [openFaqs, setOpenFaqs] = useState({});

    useEffect(() => {
        if (!faqs?.length) return;

        const defaults = {};
        faqs.forEach((item) => {
            defaults[item.title] = 0;
        });
        setOpenFaqs(defaults);
    }, [faqs]);

    const toggleFaq = (section, index) => {
        setOpenFaqs((prev) => ({
            ...prev,
            [section]: prev[section] === index ? null : index,
        }));
    };

    return { openFaqs, toggleFaq };
}
